export default {
  // Параметры даты-времени
  LuxonDateFormat: "dd.MM.yyyy",
  LuxonFullDateTimeFormat: "dd.MM.yyyy HH:mm:ss",
  LuxonShortDateTimeFormat: "dd.MM.yyyy HH:mm",

  // для создания именованных методов в CheckPermissionMixin
  CrudSuffix: ["view", "add", "edit", "delete"],
  ActionNames: {
    create: "Создание",
    update: "Изменение",
    delete: "Удаление",
    publish: "Публикация",
    unpublish: "Снятие с публикации"
  },
  PageFields: {
    Roles: {
      name: "Название",
      added_np: "Добавлен доступ",
      deleted_np: "Удален доступ",
      added_rcl: "Добавлен доступ",
      deleted_rcl: "Удален доступ"
    },
    Users: {
      name: "Имя",
      email: "Email",
      added_role: "Добавлена роль",
      deleted_role: "Удалена роль"
    },
    UserDics: {
      term: "Термин",
      value: "Значение",
      lang_code: "Язык"
    },
    Node: {
      published: "Опубликовано"
    }
  }
};
